export const PDP_URL_PREFIX = 'https://appsumo.com/products/';

export const SUBSCRIBE_URL = '/accounts/signup/email-subscribe/';

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i; // NOSONAR

export const APPSUMO_PLUS_DEAL_ID = 1735;
export const DEFAULT_PLUS_DISCOUNT_PERCENTAGE = 10;

export const NEXT_ONE_TAP_EXPERIMENT_NAME = 'indexable-google-one-tap';
export const ASKSUMO_CLEANUP_EXPERIMENT_NAME = 'asksumo-v2';
export const SWAG_PROMO_EXPERIMENT_NAME = 'swag-promo';
export const PROJECT_FOMO_EXPERIMENT_NAME = 'nav-project-fomo';
export const GA4_MIGRATION_EXPERIMENT_NAME = 'ga4-migration';
export const NAV_FREE_DEALS_EXPERIMENT_NAME = 'nav-free-deals';

export const SWAG_PROMO_CAMPAIGN_NAME = 'sd-swag-promo-2023';

// Social media share URLs
export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer/sharer.php?';
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet?';
export const LINKEDIN_SHARE_URL =
  'https://www.linkedin.com/shareArticle?mini=true&';

export const FACEBOOK_LOGIN_EXPERIMENT = 'facebook-login';
